import VueCookies from 'vue-cookies'
import axios from 'axios'

// state
export const state = {
  isRegisterProcessing: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  registerStart(state) {
    state.isRegisterProcessing = true
  },
  registerSuccess(state) {
    state.isRegisterProcessing = false
  },
  registerFail(state) {
    state.isRegisterProcessing = false
  },
}
// actions
export const actions = {
  async postRegister({ commit, dispatch }, payload) {
    let token = null
    try {
      commit('registerStart')
      token = await axios.post(`auth/register`, payload)
      commit('registerSuccess')
      dispatch('auth/storeToken', token, { root: true })
      dispatch('profile/howToPlay/openHowToPlayModal', {}, { root: true })

      const selectedAthletes = VueCookies.get('epl-landing-athletes')
      const selectedRound = VueCookies.get('epl-landing-athletes-round')
      if (selectedAthletes.length && selectedRound.length) {
        selectedAthletes.split(',')
          .filter((athlete) => !!athlete)
          .map((athlete) => {
            dispatch('rounds/assignAthleteIntoRound/assignAthleteToRound', {
              roundId: parseInt(selectedRound),
              athleteId: parseInt(athlete),
            }, { root: true })
          })
        VueCookies.remove('epl-landing-athletes')
        VueCookies.remove('epl-landing-athletes-round')
      }
    } catch (e) {
      commit('registerFail')
    }
    return token
  },
  async postBet21Register({ commit }, payload) {
    try {
      commit('registerStart')
      const response = await axios.post(`auth/bet21/register`, payload)
      commit('registerSuccess')
      return response
    } catch (e) {
      commit('registerFail')
    }
  },
}
